<template>
  <div v-if="loadBrief === true">
    <div class="Tb_data_briefing" v-if="boardList.length > 0">
      <ul>
        <li v-for="(brief, i) in boardList" :key="i" @click="goDetail(i, brief)">
          <h2>{{ brief.Date }} {{ $t("brief['brief']") }}</h2>
          <p>{{ brief.title }}</p>
        </li>
      </ul>
    </div>
    <div class="Tb_data_briefing">
      <div class="nodata_com" v-if="boardList.length === 0">
        {{ $t("brief['noData']") }}
      </div>
    </div>
  </div>
  <div class="Tb_data_briefing" v-if="loadBrief === false">
    <div class="loading_spinner_trade">
      <div class="loading_circle_trade"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "BriefTable",
  props: {
    boardType: String,
    boardList: Array,
    briefList: Array,
  },
  computed: {
    ...mapState("board", ["briefDetail", "loadBrief"]),
  },
  methods: {
    ...mapMutations("board", ["detailBrief"]),

    goDetail(i, brief) {
      this.$router.push({
        path: `/board/${this.boardType}/${i}`,
      });
      this.detailBrief(brief);
    },
  },
};
</script>

<style scoped>
.detail {
  display: none;
}

.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 50px auto;
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.loading_spinner {
  margin: auto;
  text-align: center;
  padding-top: 100px;
}

.loading_circle {
  margin: 0 auto;
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
